import { SvgIcon, SvgIconProps } from '@mui/material';

export const XIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox='0 0 40 40'>
    <path d='M23.4 17.7 34.5 5H32l-9.7 11-7.8-11H5.5l11.7 16.7L5.5 35h2.6l10.3-11.6L26.6 35h8.9L23.4 17.7Zm-3.7 4.1-1.2-1.6L9.1 6.9h4l7.7 10.7 1.2 1.7L31.9 33h-4l-8.2-11.3Z' />
  </SvgIcon>
);
